import React from 'react';
import { useTranslation } from 'react-i18next';
import { adjustToLocalDate } from '../helper/downloadCSVHelper';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const DatePickerLayout = ({ label, selectedDate, keyValue, minDate, maxDate, setDateFrom, setDateTo, disabled }) => {
  const { t } = useTranslation();

  const handleDateChange = (key, date) => {
    if (key === 'from') {
      setDateFrom(adjustToLocalDate(date));
    }
    if (key === 'to') {
      setDateTo(adjustToLocalDate(date));
    }
  };

  return (
    <div className="form-group flex flex-col gap-2">
      <label className='text-customgreen'>{t(label)}</label>
      <DatePicker
        selected={selectedDate}
        onChange={(date) => handleDateChange(keyValue, date)}
        className="w-full zIndex border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 p-2.5"
        placeholderText="DD/MM/YYYY"
        dateFormat="dd/MM/yyyy"
        minDate={minDate}
        maxDate={maxDate}
        onKeyDown={(e) => e.preventDefault()}
        disabled={disabled}
        showYearDropdown
        scrollableYearDropdown
      />
    </div>
  );
};

export default DatePickerLayout;
